module.exports = __webpack_public_path__ + "img/5.edbc456a.jpg";